var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getAddressWrapper from "@ledgerhq/coin-framework/bridge/getAddressWrapper";
import { defaultUpdateTransaction, makeAccountBridgeReceive, makeScanAccounts, makeSync, } from "@ledgerhq/coin-framework/bridge/jsHelpers";
import { patchOperationWithHash } from "@ledgerhq/coin-framework/operation";
import { PolkadotAPI } from "../api";
import resolver from "../hw-getAddress";
import createTransaction from "../js-createTransaction";
import estimateMaxSpendable from "../js-estimateMaxSpendable";
import getTransactionStatus from "../js-getTransactionStatus";
import prepareTransaction from "../js-prepareTransaction";
import buildSignOperation from "../js-signOperation";
import { makeGetAccountShape } from "../js-synchronisation";
import { loadPolkadotCrypto } from "../polkadot-crypto";
import { assignFromAccountRaw, assignToAccountRaw } from "../serialization";
import { getPreloadStrategy, hydrate, preload } from "../preload";
/**
 * Broadcast the signed transaction
 * @param {signature: string, operation: string} signedOperation
 */
const broadcast = (polkadotAPI) => ({ signedOperation: { signature, operation }, }) => __awaiter(void 0, void 0, void 0, function* () {
    yield loadPolkadotCrypto();
    const hash = yield polkadotAPI.submitExtrinsic(signature);
    return patchOperationWithHash(operation, hash);
});
export function buildCurrencyBridge(signerContext, network, cacheFn) {
    const polkadotAPI = new PolkadotAPI(network, cacheFn);
    const getAddress = resolver(signerContext);
    const getAccountShape = makeGetAccountShape(polkadotAPI);
    const scanAccounts = makeScanAccounts({
        getAccountShape,
        getAddressFn: getAddressWrapper(getAddress),
    });
    return {
        getPreloadStrategy,
        preload: preload(polkadotAPI),
        hydrate,
        scanAccounts,
    };
}
export function buildAccountBridge(signerContext, network, cacheFn) {
    const polkadotAPI = new PolkadotAPI(network, cacheFn);
    const getAddress = resolver(signerContext);
    const receive = makeAccountBridgeReceive(getAddressWrapper(getAddress));
    const signOperation = buildSignOperation(signerContext, polkadotAPI);
    const getAccountShape = makeGetAccountShape(polkadotAPI);
    const sync = makeSync({ getAccountShape });
    return {
        estimateMaxSpendable: estimateMaxSpendable(polkadotAPI),
        createTransaction,
        updateTransaction: defaultUpdateTransaction,
        getTransactionStatus: getTransactionStatus(polkadotAPI),
        prepareTransaction: prepareTransaction(polkadotAPI),
        sync,
        receive,
        signOperation,
        broadcast: broadcast(polkadotAPI),
        assignFromAccountRaw,
        assignToAccountRaw,
    };
}
export function createBridges(signerContext, network, cacheFn) {
    return {
        currencyBridge: buildCurrencyBridge(signerContext, network, cacheFn),
        accountBridge: buildAccountBridge(signerContext, network, cacheFn),
    };
}
//# sourceMappingURL=js.js.map